import * as React from 'react';
import * as Moment from 'moment';
import { WTable } from '../core/table/WTable';
import { getTempLog } from './functions/tempLog'

export interface TempLogProps {

}

export interface TempLogState {

}

export class TempLog extends React.Component<TempLogProps, TempLogState> {

    constructor(props: any) {
        super(props);
        this.state = {

        };
    }

    componentDidMount(): void {

    }

    render(): JSX.Element {
        return <div>
            {this.renderLogTable()}
        </div>;
    }

    renderLogTable(): JSX.Element {
        const logs = getTempLog();
        // console.log(logs);
        const data = logs.sort((a: any, b: any) => b.stamp - a.stamp).map((r: any) => {
            return {
                time: Moment(r.stamp).format('DD.MM.YY HH:mm'),
                name: r.name,
                description: r.description,
                data: JSON.stringify(r.data)
            };
        });
        const fulltextFilterMethod = (filter: any, row: any) => {
            return row[filter.id] && (row[filter.id] + '').toLowerCase().indexOf(filter.value.toLowerCase()) !== -1;
        };
        const columns = [
            {
                accessor: 'time',
                id: 'time',
                Header: 'Uhrzeit',
                type: 'time',
                filterMethod: fulltextFilterMethod
            },
            {
                accessor: 'name',
                id: 'name',
                Header: 'Bezeichnung',
                type: 'text',
                filterMethod: fulltextFilterMethod
            },
            {
                accessor: 'description',
                id: 'description',
                Header: 'Beschreibung',
                type: 'text',
                filterMethod: fulltextFilterMethod
            },
            {
                accessor: 'data',
                id: 'data',
                Header: 'Daten',
                type: 'text',
                filterMethod: fulltextFilterMethod
            }
        ];

        return <div>
            <WTable
                entity='TempLog'
                columns={columns}
                data={data}
                customClass='Custom-ETA'
                onAction={() => { }}
                showPagination={true}
                pageSize={20}
                columnWidths={[100]}
            />
        </div>;
    }

}
